module.exports = OSjs;